import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ZawodnikLanding from './ZawodnikLanding';
import ZawodnikRally from './ZawodnikRally';
import ZawodnikClimb from './ZawodnikClimb';
import Event from './Event';
import Elearning from './Elearning';
import Polityka from './Polityka';
import Privacy from './Privacy';
import Terms from './Terms';
import { LanguageProvider } from './LanguageContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
const path = window.location.pathname.toLowerCase();
const isZawodnik = path === '/zawodnik' || path === '/zawodnik/';
const isZawodnikRally = path === '/zawodnik-rally' || path === '/zawodnik-rally/';
const isZawodnikClimb = path === '/zawodnik-climb' || path === '/zawodnik-climb/';
const isEvent = path === '/event' || path === '/event/';
const isElearning = path === '/elearning' || path === '/elearning/';
const isPolityka = path === '/polityka-prywatnosci' || path === '/polityka-prywatnosci/';
const isPrivacy = path === '/privacy' || path === '/privacy/';
const isTerms = path === '/terms' || path === '/terms/';

root.render(
  <React.StrictMode>
    <LanguageProvider>
      {isZawodnik ? <ZawodnikLanding /> :
       isZawodnikRally ? <ZawodnikRally /> :
       isZawodnikClimb ? <ZawodnikClimb /> :
       isEvent ? <Event /> :
       isElearning ? <Elearning /> :
       isPolityka ? <Polityka /> :
       isPrivacy ? <Privacy /> :
       isTerms ? <Terms /> :
       <App />}
    </LanguageProvider>
  </React.StrictMode>
);
